// url.js
export const API_URLS = {
    BASE_URL: "https://backend.sbk.sameteo.com/"
};
